import Newsletters from 'components/newsletters/newsletters';

const newslettersConfig = {
  name: 'newsletters',
  class: Newsletters,
};

export default newslettersConfig;
